<template>
    <div class="sec-cont">
        <Head :title="__('Users')"/>
        <div class="mb-6 flex flex-col md:flex-row gap-3 justify-between items-center ticket-filters">
            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset"></search-input>
            <!--            <div class="filter-add-new flex flex-col gap-3 md:flex-row w-full items-center max-w-md">
                            <select-input v-model="form.role_id" class=" mr-2 w-full">
                                <option :value="null">{{ __('Filter by role') }}</option>
                                <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
                            </select-input>
                            <Link class="btn-indigo" :href="route('users.create')">
                                <span>{{ __('Create New') }}</span>
                            </Link>
                        </div>-->
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">{{ __('Title') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Activity Type') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Date') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Class') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Teacher') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Action ') }}</th>
                </tr>
                <tr v-for="user in interviews.data" :key="interviews.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100"
                >
                    <td class="border-t">
                        <span class="flex items-center px-6 py-4">
                     Sports
                        </span>

                    </td>
                    <td class="border-t">

                        <span class="flex items-center px-6 py-4">
                     Activity
                        </span>

                    </td>
                    <td class="border-t">
                           <span class="flex items-center px-6 py-4">
                      19-01-2025
                        </span>

                    </td>
                    <td class="border-t capitalize">
                        <span class="flex items-center px-6 py-4">
                            Class 9
                        </span>
                    </td>

                    <td class="border-t capitalize">
                         <span class="flex items-center px-6 py-4">
                                Teacher 1, Teacher 2, Teacher 3
                        </span>
                    </td>


                    <td class="w-px border-t flex items-center px-6 py-4 focus:text-indigo-500">
                        <Link class="btn btn-primary" :href="route('interview.edit', { applicant: user.id })">
                            View
                        </Link>
                    </td>
                </tr>
                <tr v-if="interviews.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No activity found.</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="interviews.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        SearchInput,
        Head,
        Icon,
        Link,
        SelectInput,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        interviews: Object,
        roles: Array,
        interviewStatusList: {
            type: Object,
            required: true,
        },
    },

    data() {
        console.log(this.interviewStatusList)
        return {
            form: {
                search: this.filters.search,
                selectedStatus: this.filters.interviewStatusList ?? null,
            },
            visible: {
                project_create: false,
                create_workspace: false,
                menu_workspace: false,
                menu_recent: false,
                menu_star: false,
                menu_create: false,
            },
            selectedStatus: '',
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('admin.interviewList'), pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    computed: {
        transformedStatusList() {
            // Transform the object into an array format suitable for v-for
            return Object.entries(this.interviewStatusList).map(([value, label]) => ({
                value,
                label,
            }))
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        selectStatus(status) {
            this.form.selectedStatus = status
            this.visible.menu_recent = false // Close the dropdown after selection
        },
    },
}
</script>
